import { SiteButton } from '../components/site/SiteButton';
import { usePageSeo } from '../hooks/usePageSeo';
import { PAGE_SEO } from '../lib/seo';
import '../styles/not-found-page.css';

export function NotFoundContent() {
  return (
    <div className="not-found-showcase">
      <section className="not-found">
        <div className="container">
          <div className="not-found__inner">
            <span className="not-found__tag">404</span>
            <h1 className="not-found__title">Page not found</h1>
            <p className="not-found__subtitle paragraph-02 text-dark-grey-two">
              The page you're looking for doesn't exist or may have moved.
            </p>
            <SiteButton href="/">Back to home</SiteButton>
          </div>
        </div>
      </section>
    </div>
  );
}

export function NotFoundPage() {
  usePageSeo(PAGE_SEO.notFound);

  return <NotFoundContent />;
}
